import { css } from '@emotion/react';

const GradientBackground = ({ children }: React.PropsWithChildren) => {
  return (
    <>
      <div css={gradient} />
      {children}
    </>
  );
};

export default GradientBackground;

const gradient = css`
  background: radial-gradient(
    98.72% 40.38% at 49.87% -13.38%,
    rgba(207, 185, 125, 0.32) 0%,
    rgba(148, 129, 76, 0) 100%
  );
  height: 100%;
  width: 100%;
  position: absolute;
  opacity: 60%;
  pointer-events: none;
`;
